import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';

const PageHeaderText: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 1,
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderText;
